/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Not_ConfiguredInputs */

const th_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้เปิดใช้งานการแจ้งเตือนสำหรับระบบนี้`)
};

const en_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are not switched on for this deployment yet.`)
};

const ja_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この環境ではまだ通知が有効になっていません。`)
};

const zh_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此安装尚未开启通知。`)
};

const es_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notificaciones aún no están activadas en esta instalación.`)
};

const pt_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As notificações ainda não estão ligadas nesta instalação.`)
};

const id_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi belum dinyalakan untuk pemasangan ini.`)
};

const fr_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications ne sont pas encore activées sur ce déploiement.`)
};

const tl_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi pa nakabukas ang mga notipikasyon para sa instalasyong ito.`)
};

const vi_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản cài này chưa bật thông báo.`)
};

const ko_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 설치본에는 알림이 아직 켜져 있지 않습니다.`)
};

const de_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen sind für diese Installation noch nicht eingeschaltet.`)
};

const ru_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления для этой установки ещё не включены.`)
};

const tr_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kurulumda bildirimler henüz açılmadı.`)
};

const it_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le notifiche non sono ancora attive per questa installazione.`)
};

const pl_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia nie są jeszcze włączone w tej instalacji.`)
};

const uk_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення для цієї інсталяції ще не ввімкнено.`)
};

const hi_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस इंस्टॉलेशन के लिए सूचनाएँ अभी चालू नहीं हैं।`)
};

const ar_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُفعَّل الإشعارات لهذا التنصيب بعد.`)
};

const ms_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan belum dihidupkan untuk pemasangan ini.`)
};

const bn_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ইনস্টলেশনে বিজ্ঞপ্তি এখনও চালু হয়নি।`)
};

const zh_tw2_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個安裝尚未開啟通知。`)
};

const zh_hk2_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個安裝尚未開啟通知。`)
};

const ur_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس تنصیب کے لیے اطلاعات ابھی چالو نہیں۔`)
};

const fa_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعلان‌ها برای این نصب هنوز روشن نشده است.`)
};

const sw_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa hazijawashwa kwa usakinishaji huu bado.`)
};

const nl_push_not_configured = /** @type {(inputs: Push_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen staan voor deze installatie nog niet aan.`)
};

/**
* | output |
* | --- |
* | "Notifications are not switched on for this deployment yet." |
*
* @param {Push_Not_ConfiguredInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_not_configured = /** @type {((inputs?: Push_Not_ConfiguredInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Not_ConfiguredInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_not_configured(inputs)
	if (locale === "ja") return ja_push_not_configured(inputs)
	if (locale === "zh") return zh_push_not_configured(inputs)
	if (locale === "es") return es_push_not_configured(inputs)
	if (locale === "pt") return pt_push_not_configured(inputs)
	if (locale === "id") return id_push_not_configured(inputs)
	if (locale === "fr") return fr_push_not_configured(inputs)
	if (locale === "tl") return tl_push_not_configured(inputs)
	if (locale === "vi") return vi_push_not_configured(inputs)
	if (locale === "ko") return ko_push_not_configured(inputs)
	if (locale === "de") return de_push_not_configured(inputs)
	if (locale === "ru") return ru_push_not_configured(inputs)
	if (locale === "tr") return tr_push_not_configured(inputs)
	if (locale === "it") return it_push_not_configured(inputs)
	if (locale === "pl") return pl_push_not_configured(inputs)
	if (locale === "uk") return uk_push_not_configured(inputs)
	if (locale === "hi") return hi_push_not_configured(inputs)
	if (locale === "ar") return ar_push_not_configured(inputs)
	if (locale === "ms") return ms_push_not_configured(inputs)
	if (locale === "bn") return bn_push_not_configured(inputs)
	if (locale === "zh-TW") return zh_tw2_push_not_configured(inputs)
	if (locale === "zh-HK") return zh_hk2_push_not_configured(inputs)
	if (locale === "ur") return ur_push_not_configured(inputs)
	if (locale === "fa") return fa_push_not_configured(inputs)
	if (locale === "sw") return sw_push_not_configured(inputs)
	if (locale === "nl") return nl_push_not_configured(inputs)
	return en_push_not_configured(inputs)
});